<template>
    <section id="aboutus" class="AboutUs white">
        <div class="row">
            <div class="col s12 m12 l12 xl6 left-text description">
                <!-- <div class="title centfer">About Us</div> -->
                <div class="title show-on-medium-and-down"><img src="/assets/images/aboutus2.png"></div>
                <div class="title hide-on-large-and-down"><img src="/assets/images/aboutus.png"></div>
                We at the House of Fire Christian Church are all about growing together as a church family while increasing our biblical knowledge and, most importantly, drawing closer to Jesus Christ in our personal spritual journeys.<br><br>
                In the summer of 2017, we were overjoyed to finally open the doors of our new church building in Clifton, New Jersey, after over a decade of patience and determination. We welcome you to join us as we worship our heavenly Father, learn more about the Word of God, and fellowship with one another.<br><br> 
                "After 15 years of perseverance, we are proud to finally worship in our new church building. It has been a difficult journey, fighting for our vision and God has answered our prayers. As James 5:16 says, 'The fervent prayer of a righteous man can bring powerful results.' We are overjoyed to worship the Lord in our new home, and look forward to welcoming everyone into this new chapter that God has in store for us." &ndash; Rev. Placido Lentini
                <br><br>
                <router-link :to="{ name: 'aboutus'}">Learn More</router-link>
                <div class="pastor">
                    <table class="responsive-table">
                        <tr>
                            <td><img class="circle" src="/assets/images/pastor2.jpg"></td>
                            <td>
                                <span class="role">Lead Pastor</span>
                                <span class="name">Rev. Placido Lentini</span>
                                <p>
                                    A third generation pastor, Reverend Placido Lentini became the minister of the House of Fire Christian Church after taking over for his father. As an ordained evangelical minister, he has faithfully led his congregation for over 30 years.
                                </p>
                            </td>       
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col s12 m12 l12 xl6 image">
                <!-- <img src="/assets/images/church.jpg"> -->
            </div>
        </div>
    </section>
</template>

<script>
    // import VueRouter from 'vue-router'
    export default {
        name: 'AboutUs'
    }
</script>

<style scoped>
    .row { 
        margin-bottom: 0;
    }
    .title {
        font-weight: normal;
        font-size: 2.5rem;
        margin-bottom: 1rem;
        letter-spacing: .06rem;
    }

    .image {
        min-height: 815px;
        padding-right: 0;
        background: url(/assets/images/church.jpg);
        background-size: cover;
        background-position: center;
        height: 770px;
        /* filter: grayscale(100%); */
    }

    .AboutUs .image img {
        width: 100%;
    }

    .description {
        padding: 4rem 3rem 0rem 4rem;
        font-size: 1.25rem;
        line-height: 1.25;
    }

    td {
        vertical-align: top;
        padding: 1rem;
        padding-top: 2rem;
    }

    tr {
        border-top: 1px solid rgba(0,0,0,0.12);
        border-bottom: none;
        padding-top: 1rem;
    }

    .pastor {
        margin: 2rem 0;
    }
    .pastor img {
        width: 150px;
    }

    .pastor .role {
        display: block;
        font-size: 1rem;
        line-height: 1;
        text-transform: uppercase;
    }

    .name {
        display: block;
        font-size: 1.75rem;
        line-height: 1.25;
        font-family: NewhouseDTCond-ExtBold;
    }

    .pastor p {
        margin-top: 1rem;
        font-size: 1.25rem;
    }

    @media only screen and (min-width: 993px) {
        .show-on-medium-and-down {
            display: none;
        }
    }

    @media only screen and (max-width: 992px) {
        .hide-on-large-and-down {
            display: none;
        }

        .title {
            text-align: center;
        }

        .description {
            padding: 4rem 2rem 0rem 2rem;
        }

        table.responsive-table td:first-child {
            text-align: center;
        }
        table.responsive-table td {
            padding-left: 0;
            padding-right: 0;
        }

        .image {
            height: 300px;
        }
    }
</style>